import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  const data = _taggedTemplateLiteral(["\n                                <div class=", " @click=", " data-url=", " ref=", ">\n                                    <img src=\"", "work/", "\" />\n                                </div>\n                            "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n            <div class=\"u-hidden\" ref=", ">\n                <div class=", " ref=", ">\n                    <img class=", " src=\"", "work/", "\" ref=", "/>\n                    <div class=", "></div>\n                </div>\n\n                <div class=", ">\n                    <div class=", ">\n                        <h2 class=", " ref=", ">", "</h2>\n                    </div>\n\n                    <div class=", " ref=", ">\n                        <div class=", ">\n                            <rv-vimeo .video=", " ref=", "></rv-vimeo>\n                        </div>\n                        <div class=\"", " ", "\"\">\n                            <p class=", " ref=", ">", "</p>\n                        </div>\n                        <div class=", ">\n                            ", "\n                        </div>\n                    </div>\n\n                    <div class=", ">\n                        <a class=", " href=", ">", "</a>\n                        <a class=", " href=\"", "campaigns\">", "</a>\n                        <a class=", " href=", ">", "</a>\n                    </div>\n                </div>\n            </div>\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { Component, html } from 'lib/component';
import store from 'lib/store';
import anime from 'animejs';
import VimeoPlayer from 'components/vimeo-player';
import { ref } from 'lib/lit-ref';
import size from 'size';
import * as styles from './styles';
export default class Work extends Component {
  static get properties() {
    return {
      current: Number,
      currentVideo: Object
    };
  }

  init(options) {
    let id = options.route.current.subroute;
    this.work = store.get('content').work.filter(work => work.slug == id)[0];
    this.current = 0;
    this.direction = 0;
  }

  render() {
    let work = this.work;
    let config = store.get('content').config;
    this.refs = {};
    return html(_templateObject(), ref(this, 'wrapper'), styles.header, ref(this, 'header'), styles.background, ENV.assetsURL, work.background, ref(this, 'background'), styles.gradient, styles.content, styles.titles, styles.project, ref(this, 'title'), work.title, styles.videos, ref(this, 'videos'), styles.current, this.currentVideo, ref(this, 'vimeo'), styles.titles, styles.videoTitle, styles.title, ref(this, 'subtitle'), this.currentTitle, styles.gallery, work.videos.filter(video => video.url != this.currentVideo.url).sort(this.sortThumbs.bind(this)).map(video => html(_templateObject2(), styles.thumb, this.onThumbClick, video.url, ref(this, 'thumbs'), ENV.assetsURL, video.poster)), styles.nav, styles.navItem, this.previousProjectUrl, config.previous, styles.navItem, ENV.baseURL, config.backToCampaigns, styles.navItem, this.nextProjectUrl, config.next);
  }

  onRender() {
    document.body.classList.add('u-loading');
    this.classList.add(styles.work);
    this.loaded = new Promise((resolve, reject) => {
      if (this.refs.background.complete) resolve();else this.refs.background.onload = () => {
        this.refs.background.onload = null;
        resolve();
      };
    });
  }

  updated() {
    this.showThumbs();
  }

  get currentVideo() {
    return this.work.videos[this.current];
  }

  get currentTitle() {
    return this.work.videos[this.current].title;
  }

  sortThumbs(a, b) {
    let ia = this.work.videos.indexOf(a);
    let ib = this.work.videos.indexOf(b);
    if (ia > this.current && ib < this.current) return -1;
    return ia - ib;
  }

  async onThumbClick(event) {
    let target = event.currentTarget;
    let index = this.work.videos.findIndex(video => video.url == target.getAttribute('data-url'));
    if (index === this.current) return;
    this.direction = Math.sign(index - this.current);
    await this.hideThumbs();
    this.current = index;
  }

  async hideThumbs() {
    anime.remove(this.refs.thumbs);
    await Promise.all([anime({
      targets: this.refs.thumbs,
      opacity: {
        value: 0,
        easing: 'easeOutQuart'
      },
      translateX: 20 * -this.direction,
      easing: 'easeInCubic',
      duration: 300,
      delay: anime.stagger(40 * this.direction)
    }).finished, this.refs.vimeo.leave()]);
  }

  showThumbs() {
    setTimeout(() => {
      // this.refs.vimeo.enter()
      anime({
        targets: this.refs.thumbs,
        opacity: [0, 1],
        translateX: [20 * this.direction, 0],
        easing: 'easeOutCubic',
        duration: 300,
        delay: anime.stagger(60 * this.direction, {
          start: 100
        })
      });
    }, 100);
  }

  get nextProjectUrl() {
    let works = store.get('content').work;
    let index = works.indexOf(this.work) + 1;
    if (index > works.length - 1) index = 0;
    return "".concat(ENV.baseURL, "work/").concat(works[index].slug);
  }

  get previousProjectUrl() {
    let works = store.get('content').work;
    let index = works.indexOf(this.work) - 1;
    if (index < 0) index = works.length - 1;
    return "".concat(ENV.baseURL, "work/").concat(works[index].slug);
  }

  async animateIn(params, complete) {
    await Promise.all([this.loaded, this.refs.vimeo.loaded]);
    window.scrollTo(0, 0);
    let tl = anime.timeline({
      begin: () => {
        document.body.classList.remove('u-loading');
        this.refs.wrapper.classList.remove('u-hidden');
      },
      complete
    });
    tl.add({
      targets: this.refs.header,
      opacity: [0, 1],
      easing: 'linear',
      duration: 600
    });
    tl.add({
      targets: [this.refs.title, this.refs.subtitle],
      opacity: [0, 1],
      translateY: [20, 0],
      easing: 'easeOutQuart',
      duration: 800,
      delay: anime.stagger(80)
    }, 400);
    tl.add({
      targets: this.refs.videos,
      opacity: [0, 1],
      easing: 'easeOutCubic',
      duration: 600
    }, 600);
  }

  animateOut(params, complete) {
    anime({
      targets: this,
      opacity: 0,
      easing: 'easeOutCubic',
      duration: 600,
      complete
    });
  }

  onDestroy() {}

}
customElements.define('rv-work', Work);